import { Link } from 'react-router-dom'
import classes from './PrimaryHeader.module.scss'
import { Icon, Select } from '../../../Elements'
import useFetch from '../../../../_services/fetch'
import { RaytebRequests } from '../../../../_services'
import { useDispatch, useSelector } from 'react-redux'
import { ReducerType } from '../../../../storeManager/ReducerType'
import { LoginInterface } from '../../../../Interfaces/LoginInterface'
import {
  clearCenter,
  setCenter,
  setCenterConfig,
} from '../../../../storeManager/Reducers/centerSlice'

import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { setQueueRoom } from '../../../../storeManager/Reducers/queueSlice'
import Skeleton from 'react-loading-skeleton'
import { loginUser } from '../../../../storeManager/Reducers/userSlice'
import LoadingFit from '../../Loading/LoadingFit'

type menuRightType = {
  icon: string
  title: string
  link: string
}
type menuLeftType = {
  title: string
  onClick?: () => void
  icon: string
}
const PrimaryHeader = () => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const dispatch = useDispatch()
  const centerStore = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  // const [center, setCenterState] = useState<CenterViewModel>(centerStore);
  const getCenters = useFetch<Array<CenterViewModel>>({
    request: RaytebRequests.Doctor_GetDoctorCenter_GET({ token: user.token }),
    fetchInitialLoad: true,
    onSuccess(data) {
      if (centerStore.id && !data.some((n) => n.id === centerStore.id)) {
        dispatch(clearCenter(null))
        toast.warning('لطفا مرکز خود را انتخاب کنید')
      }
      else
        getCenterConfigs.reFetch();
    },
  })
  const getCenterConfigs = useFetch<Array<CenterConfigType>>({
    request: RaytebRequests.Doctor_GetCenterConfig_GET({
      token: user.token,
      headers: { centerId: centerStore.id },
    }),
    onSuccess(data) {
      dispatch(setCenterConfig(data))
    },
    onError(data) {
      // dispatch(setCenter(getCenters.result?.find(x => x.id === centerStore.id)))
      dispatch(setCenterConfig(null))
      toast.info(data.messages[0].message)
    },
  })
  const logout = useFetch<Array<CenterConfigType>>({
    request: RaytebRequests.Dashboard_Logout_GET({ token: user.token, browserUniqueKey: generateBrowserFingerprint().toString() }),
    onSuccess(data) {
      dispatch(loginUser({}))
      window.location.href = window.env['APP_Rayteb_Domain']!
    },
  })
  const arrRightMenu: Array<menuRightType> = [
    {
      title: 'صفحه اصلی',
      icon: 'medical-home',
      link: window.env['APP_Rayteb_Domain']!,
    },
    {
      title: 'نوبت دهی پزشکان و مراکز درمانی',
      icon: 'appointment-h',
      link: `${window.env['APP_Rayteb_Domain']!}/Appointment/fa-ir/10-0-0-0-0-2-0`,
    },
    {
      title: 'مشاوره آنلاین با پزشکان و متخصصان',
      icon: 'videocamera',
      link: `${window.env['APP_Rayteb_Domain']!}/Appointment/fa-ir/0-0-0-0-0-1-0`,
    },
    {
      title: 'نظر سنجی',
      icon: 'survey',
      link: `${window.env['APP_Rayteb_Domain']!}/survey`,
    },
    {
      title: 'غربالگری کرونا',
      icon: 'cronavirus',
      link: `${window.env['APP_Rayteb_Domain']!}/screening`,
    },
    {
      title: 'شرایط و قوانین رایطب',
      icon: 'terms-conditions',
      link: `${window.env['APP_Rayteb_Domain']!}/rayteb/fa-ir/page/Regulation`,
    },
    {
      title: 'پیشنهادات و انتقادات',
      icon: 'suggestion',
      link: `${window.env['APP_Rayteb_Domain']!}/feedback`,
    },
    {
      title: 'راهنما',
      icon: 'help-question',
      link: `${window.env['APP_Rayteb_Domain']!}/rayteb/fa-ir/page/PatientGuide`,
    },
  ]
  const [showMenuRight, setShowMenuRight] = useState<boolean>(false)
  const [showMenuLeft, setShowMenuLeft] = useState<boolean>(false)

  useEffect(() => {
    if (!centerStore.id) toast.warning('لطفا مرکز خود را انتخاب کنید')
    else
      getCenterConfigs.reFetch();
  }, [centerStore])

  return (
    <>
      <LoadingFit isLoading={logout.isLoading} fixed={true} />
      <header className={classes.primaryHeader}>
        <div className={classes.primaryHeader__head}>
          <Icon
            icon={`${!showMenuRight ? ' rayteb-menu-bars' : 'rayteb-android-add'
              }`}
            className={`mr-3 text-3xl  duration-150 transition-all ${showMenuRight ? 'rotate-45' : ''
              }`}
            onClick={() => {
              setShowMenuRight(!showMenuRight)
              setShowMenuLeft(false)
              if (!showMenuRight) document.body.style.overflow = 'hidden'
              else document.body.style.overflow = 'auto'
            }}
          />
          <Link to={window.env['APP_Rayteb_Domain']!}>
            <img src='./images/Header-Logo-01.png' className='h-11' />
          </Link>
        </div>
        <MenuRight menus={arrRightMenu} show={showMenuRight} />
      </header>
      <div className={classes.toolbar}>
        {!getCenters.isLoading ? (
          <>
            <Select
              onChange={(e) => {
                if (e.target.value && e.target.value != '') {
                  // setCenterState(getCenters.result?.find((n) => n.id == e.target.value)!)
                  dispatch(setCenter(getCenters.result?.find(x => x.id === parseInt(e.target.value))))
                  dispatch(setQueueRoom(null))
                }
              }}
              debounceTime={0}
              value={centerStore.id}
              className='!bg-primaryLight text-white px-5 h-8'
            >
              <option value={''}>انتخاب مرکز</option>
              {getCenters.result?.map((n, i) => (
                <option key={i} value={n.id}>
                  {n.name}
                </option>
              ))}
            </Select>
          </>
        ) : (
          <Skeleton className=' px-5 h-7' width={200} />
        )}
        <div className={classes.toolbar__menu}>
          {/* <Icon icon='rayteb-envelop-message' className='text-3xl' /> */}
          <Icon
            icon='rayteb-ellipsis-v'
            className='text-3xl font-normal'
            onClick={() => {
              setShowMenuLeft(!showMenuLeft)
              document.body.style.overflow = 'auto'
              setShowMenuRight(false)
            }}
          />
        </div>
        <MenuLeft
          show={showMenuLeft}
          menus={[
            {
              title: 'خروج',
              onClick: () => {
                logout.reFetch()
              },
              icon: 'sign-out',
            },
          ]}
        />
      </div>
    </>
  )
}
const MenuRight = ({
  menus,
  show,
}: {
  menus: Array<menuRightType>
  show: boolean
}) => (
  <div
    className={`absolute top-[5rem] duration-500 transition-all right-0 ${show ? '' : 'translate-x-96'
      } w-72 h-[calc(100%_-_80px)] overflow-auto bg-primary z-[999999]`}
  >
    <ul className='flex flex-col w-full  px-4'>
      {menus.map((x, i) => (
        <li
          key={i}
          className='w-full border-b-[1px] border-primaryLight
       text-white py-2 px-2'
        >
          <Link to={x.link} className=' flex justify-start items-center gap-3'>
            <Icon icon={`rayteb-${x.icon}`} className='text-2xl' />
            <span className='text-xs'>{x.title}</span>
          </Link>
        </li>
      ))}
    </ul>
  </div>
)
const MenuLeft = ({
  menus,
  show,
}: {
  menus: Array<menuLeftType>
  show: boolean
}) => (
  <div
    className={`absolute top-full cursor-pointer left-0 ${show ? 'block' : 'hidden'
      } w-44 overflow-auto bg-primary z-[999999]`}
  >
    <ul className='flex flex-col w-full  px-4'>
      {menus.map((x, i) => (
        <li
          onClick={() => x.onClick?.()}
          key={i}
          className='w-full border-b-[1px] gap-2  border-warnDark
       text-white py-2 px-2 flex justify-center items-center'
        >
          <Icon icon={`rayteb-${x.icon}`} className='text-2xl w-[20%]' />
          <span className='text-xs w-[80%] text-center'>{x.title}</span>
        </li>
      ))}
    </ul>
  </div>
)
export default PrimaryHeader

function generateBrowserFingerprint() {
  const navigatorInfo = window.navigator;
  const screenInfo = window.screen;

  // جمع‌آوری اطلاعات کلیدی مرورگر و دستگاه
  const data = [
    navigatorInfo.userAgent,                // مرورگر و سیستم‌عامل
    navigatorInfo.language || '',          // زبان مرورگر
    navigatorInfo.platform || '',          // پلتفرم (مانند ویندوز، مک، لینوکس)
    screenInfo.width + 'x' + screenInfo.height, // ابعاد صفحه نمایش
    screenInfo.colorDepth || '',           // عمق رنگ
    new Date().getTimezoneOffset(),        // منطقه زمانی کاربر
    getCanvasFingerprint(),                // اثر انگشت Canvas
  ].join('::');

  // هش کردن داده‌ها برای تولید کد یکتا
  return hashString(data);
}

// تولید اثر انگشت Canvas
function getCanvasFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context!.textBaseline = 'top';
    context!.font = '14px Arial';
    context!.fillText('Browser Fingerprint', 10, 10);
    return canvas.toDataURL();
  } catch (error) {
    return 'unsupported';
  }
}

// تابع هش ساده برای تولید یک شناسه کوتاه
function hashString(string) {
  let hash = 0, i, chr;
  if (string.length === 0) return hash;
  for (i = 0; i < string.length; i++) {
    chr = string.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // تبدیل به عدد صحیح 32 بیتی
  }
  return hash.toString(16); // تبدیل به رشته هگزادسیمال
}
